import { WebSocketHandler } from "../../../plugins/webSocketHandler.js"

export default {
    async connectToWebSocket(context, payload) {
        try {
            context.state.mySocket = new WebSocketHandler(payload.websocketurl, payload.loggedInUserId, false)
            context.state.mySocket.connect()
            return context.state.mySocket
        } catch (error) {
            console.error(
                `[connectToWebSocket][Store][Error occured while connecting To WebSocket--->${error}]`
            );
        }
        return null
    }
};